export default __webpack_public_path__ + "static/backstory_diamond-8d14833b087c1bad3c98b5f82621b2e4.png";